import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerAuthService } from '@teem/app/core/services/customer-auth.service';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { ProfileService } from '@teem/app/core/services/profile.service';
// import { SignupModalComponent } from '@teem/customer/modals/signup-modal/signup-modal.component';
import { environment } from '@teem/environments/environment';

@Component({
	selector: 'signin-modal',
	templateUrl: './signin-modal.component.html',
	styleUrls: ['./signin-modal.component.scss']
})
export class SigninModalComponent {
	@Output() authState = new EventEmitter<string>();
	signinForm: FormGroup;
	isSubmitted: boolean = false;

	constructor(
		private fb: FormBuilder,
		private modalService: NgbModal,
		public activeModal: NgbActiveModal,
		private profileService: ProfileService,
		private loaderService: LoaderService,
		private customerAuthService: CustomerAuthService
	) {
		this.signinForm = this.fb.group({
			email: ['', [Validators.required, Validators.email]],
			password: ['', [Validators.required, Validators.minLength(6)]],
		});
	}

	ngOnInit(): void {
		//
	}

	isFormValid(): boolean {
		return this.signinForm.get('email')?.valid && this.signinForm.get('password')?.valid;
	}

	authToggle(state: string) {
		this.authState.emit(state);
	}

	onSubmit() {
		this.isSubmitted = true;
		if (this.signinForm.valid) {
			const loginData = {
				'username': this.signinForm.get('email').value,
				'password': this.signinForm.get('password').value
			}
			this.loaderService.startLoading();
			this.profileService.signin(loginData).subscribe({
				next: (res: any) => {
					this.loaderService.stopLoading();
					this.customerAuthService.login();
					this.activeModal.close(res);
					if(res.intended_url?.includes("checkout")){
						window.location.href = res.intended_url;
					}else{
						window.location.reload();
					}
				},
				error: (err) => {
					this.loaderService.stopLoading();
					// Set server side error
					if (err.status === 422) {
						if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
						  let validationErrors = err.error.errors;			
						  Object.keys(validationErrors).forEach((prop) => {
							this.signinForm.get(prop)?.setErrors({
							  serverError: validationErrors[prop]
							})
						  })
						}
					} else if (err.status === 403 && err.error) {
						this.signinForm.get('email')?.setErrors({serverError: err.error.error})
					}
					// const errors = err.error?.errors;
					// if (errors?.email) {
					// 	this.signinForm.get('email')?.setErrors({ serverError: errors.email[0] });
					// }
				},
			});
		} else {
			this.signinForm.markAllAsTouched(); // Show errors if form is invalid
		}
	}

	openSignUpModal(): void {
		this.activeModal.close({});
		// const modalRef = this.modalService.open(SignupModalComponent, {
		// 	backdrop: 'static',
		// 	keyboard: false
		// });
	}

	closeLogin() {
		this.activeModal.close({});
		window.history.back();
		// window.location.href = `${environment.baseUrl}/storefronts`;
	}

	continueAsGuest(){
		let guest_route: any = (window as any).guestRoute ? (window as any).guestRoute : null;
		console.log(guest_route);
		window.location.href = guest_route;
	}
}